import IconCircled, { ICON_CIRCLE_SIZE } from './IconCircled';

export default IconCircled;
export { ICON_CIRCLE_SIZE };
